import * as yup from 'yup';

export const corporateEditEmployeeSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    phone_no: yup.string().required("phone Number is required"),
    ss_number: yup.string()
        .required("Social Security Number is required"),
    email: yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    address: yup.string()
        .required("Address is required"),
    about: yup.string()
        .max(500, "About section cannot exceed 500 characters")
        .required("About section is required"),
});
